// extracted by mini-css-extract-plugin
export default {"actions":"RecentFolderRow-actions-Z_qCn TableRowCell-cell-giPrj"};